export const variables = {
  // ---------------------------------------------------------------------------
  // Colors
  // ---------------------------------------------------------------------------
  colors: {
    white: '#ffffff',
    black: '#000000',
    ebony: '#11142D',
    mercury: '#eae9e9',
    waterloo: '#808191',
    casablanca: '#f7b648',
  },

  // ---------------------------------------------------------------------------
  // Responsive rules
  // ---------------------------------------------------------------------------
  responsive: {
    highres: '1440px',
    desktop: '1200px',
    tablet: '992px',
    mobile: '768px',
    small: '400px',
  },
};
